<!-- 答题流程 -->
<template>
  <div
    class="container "
    :style="{
      paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
    }"
  >
    <div class="navigator" v-if="platform == 'app'">
      <div class="back_share">
        <img
          class="back_img"
          src="@/assets/images/home/back@2x.png"
          @click="back()"
          @touchmove.stop.prevent
          alt
        />
        <div>{{ this.title }}</div>
      </div>
    </div>
    <div class="answerPage">
      <!-- 题目 -->
      <div class="quesion_box" v-if="quesionData.questions">
        <div class="quesion_progress">
          <div class="num_box">
            <div class="quesion_num">
              <span class="now_num">{{ currentIndex + 1 }}</span>
              <span class="total_num">/{{ quesionData.questions.length }}</span>
            </div>
            <!-- <div class="sheet_box">
              <img
                class="sheet_img"
                src="@/assets/images/answer/answer_sheet.png"
                alt=""
              />
              <span class="sheet_text" @click="showAnswerCard">答题卡</span>
            </div> -->
          </div>
          <div class="progress_box">
            <van-progress
              :percentage="
                ((currentIndex + 1) / quesionData.questions.length) * 100
              "
              pivot-text=""
              :stroke-width="8"
              color="linear-gradient(90deg, #79E695, #5AD8B7)"
              track-color="#F5F6FA"
            />
          </div>
        </div>
        <div class="question_guidelines" v-if="type===2&&quesionData.guidelines">
          {{ quesionData.guidelines }}
        </div>
        <div class="quesion_content">
          <div class="quesion_title">
            {{ currentIndex + 1 }}.{{ currentItem.stem }}
          </div>
          <div class="quesion_suntitle">{{ currentItem.subtitle }}</div>
          <!-- 程度题 -->
          <div class="answer_content" v-if="currentItem.type == 'RATING'">
            <div :id="'ratingBox' + currentIndex" class="rating_box"></div>
            <div class="rating_text">
              <div class="rating_text_inner inner_left">
                {{ currentItem.dimensionMinDisplay }}
              </div>
              <div class="rating_text_inner inner_right">
                {{ currentItem.dimensionMaxDisplay }}
              </div>
            </div>
            <div
              class="select_content"
              v-if="getSelectedAnswer(currentIndex).selectedIndex !== null"
            >
              <span>已选择：</span
              >{{ getSelectedAnswer(currentIndex).selectedContent }}
            </div>
          </div>
          <!-- 单选题（选项为文本类型） -->
          <div
            class="answer_content_single"
            v-if="
              currentItem.type == 'SINGLE' && currentItem.optionType == 'TEXT'
            "
          >
            <img
              class="quesion_img"
              v-if="currentItem.imageUrl"
              :src="currentItem.imageUrl"
              alt=""
            />
            <div class="answer_list">
              <div
                :class="
                  getSelectedAnswer(currentIndex) &&
                  getSelectedAnswer(currentIndex).selectedIndex == index + 1
                    ? 'answer_item active'
                    : 'answer_item'
                "
                v-for="(item, index) in currentItem.options"
                :key="index"
                @click="handleSingleItemClick(item, index, 'SINGLE')"
              >
                <div class="answer_item_inner">{{ item.content }}</div>
              </div>
            </div>
          </div>
          <!-- 单选题（选项为图片类型） -->
          <div
            class="answer_content_single"
            v-if="
              currentItem.type == 'SINGLE' && currentItem.optionType == 'IMAGE'
            "
          >
            <img
              class="quesion_img"
              v-if="currentItem.imageUrl"
              :src="currentItem.imageUrl"
              alt=""
            />
            <div class="answer_list_image">
              <div class="answer_list_image_item" v-for="(item, index) in currentItem.options" :key="index">
                <div
                  :class="
                    getSelectedAnswer(currentIndex) &&
                    getSelectedAnswer(currentIndex).selectedIndex == index + 1
                      ? 'answer_item_group active'
                      : 'answer_item_group'
                  "
                  @click="handleSingleItemClick(item, index, 'SINGLE')"
                >
                  <span class="group_quesion_index">{{
                    String.fromCharCode(65 + index)
                  }}</span>
                  <img class="answer_item_img" :src="item.content" alt="" />
                </div>
              </div>
            </div>
          </div>
          <!-- 多组选项题（文本型） -->
          <div
            class="answer_content_text_group"
            v-if="
              currentItem.type == 'GROUP' &&
                currentItem.questionType == 'SINGLE'
            "
          >
            <div
              v-for="(groupItem, groupIndex) in currentItem.groupQuestions"
              :key="groupIndex"
            >
              <div class="group_quesion_text_content">
                <div
                  class="group_quesion_text_title"
                  @click="handleGroupTextClick(groupItem, groupIndex)"
                >
                  <div class="status_box">
                    <div
                      class="selected_status"
                      v-if="getGroupSelectedAnswer(currentIndex, groupIndex)"
                    >
                      已选择
                    </div>
                    {{ groupItem.stem }}
                  </div>
                  <img
                    v-if="!groupItem.answerShow"
                    src="@/assets/images/answer/down_arrow.png"
                    alt=""
                  />
                  <img
                    v-if="groupItem.answerShow"
                    src="@/assets/images/answer/up_arrow.png"
                    alt=""
                  />
                </div>
                <div class="answer_group_list" v-if="groupItem.answerShow">
                  <div
                    :class="
                      getGroupSelectedAnswer(currentIndex, groupIndex) &&
                      getGroupSelectedAnswer(currentIndex, groupIndex)
                        .selectedIndex ==
                        index + 1
                        ? 'answer_item active'
                        : 'answer_item'
                    "
                    v-for="(item, index) in groupItem.options"
                    :key="index"
                    @click="
                      handleSingleItemClick(item, index, 'GROUP', groupIndex)
                    "
                  >
                    <div class="answer_item_inner">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 多组选项题（程度选择型） -->
          <div
            class="answer_content_rating_group"
            v-if="
              currentItem.type == 'GROUP' &&
                currentItem.questionType == 'RATING'
            "
          >
            <div
              v-for="(groupItem, groupIndex) in currentItem.groupQuestions"
              :key="groupIndex"
            >
              <div class="group_quesion_title">
                {{ groupItem.stem }}
              </div>
              <div
                :id="'groupRatingBox' + groupIndex"
                class="group_rating_box"
              ></div>
              <div class="rating_text">
                <div class="rating_text_inner inner_left">
                  {{ groupItem.dimensionMinDisplay }}
                </div>
                <div class="rating_text_inner inner_right">
                  {{ groupItem.dimensionMaxDisplay }}
                </div>
              </div>
              <div
                class="select_content"
                v-if="getGroupSelectedAnswer(currentIndex, groupIndex)"
              >
                <span>已选择：</span
                >{{
                  getGroupSelectedAnswer(currentIndex, groupIndex)
                    .selectedContent
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_box">
        <van-button
          type="default"
          class="btn_item"
          @click="toPrevious"
          v-if="currentIndex > 0"
        >
          上一题
        </van-button>
        <van-button
          type="default"
          class="btn_item"
          @click="toNext"
          v-if="
            quesionData.questions &&
            currentIndex < quesionData.questions.length - 1&&
            isCurrentDone(currentIndex)
          "
        >
          <!-- :class="{ disabled_btn: checkCurrentQuestion() }"
          :disabled="checkCurrentQuestion()" -->
          下一题
        </van-button>
        <van-button
          type="default"
          class="btn_item"
          @click="submit"
          v-if="ShowSubmitButton"
          >
          提交
        </van-button>
      </div>
      <van-dialog
        class="dialog_box"
        v-model="show"
        title="指导语"
        :overlayStyle="overlayStyle"
        :showConfirmButton="false"
      >
        <div class="dialog_content">
          <div class="dialog_child">
            
            <div class="diloag_child_content" style="" v-if="type == 1">
              {{ quesionData.guidelines }}
            </div>
          </div>
          <div class="dialog_btn" @click="show = false">
            我了解了，开始答题
          </div>
        </div>
      </van-dialog>
      <van-popup
        v-model="showCard"
        round
        position="bottom"
        :style="{ maxHeight: '50%' }"
      >
        <div class="quesion_box question_card_wrap">
          <div
            v-for="(item, index) in quesionData.questions"
            :key="index"
            class="question_card_item"
            :class="{ active: item.isDone }"
            @click="toCardItem(item, index)"
          >
            {{ index + 1 }}
            <div class="card_item_tips">
              {{ item.isDone ? "已作答" : "未作答" }}
            </div>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 指导语 -->

    <router-view class></router-view>
  </div>
</template>

<script>
import { getQuesion, submitAnswer } from "@/api/answer";
import { Toast } from "vant";
export default {
  data() {
    // 这里存放数据
    return {
      type: "",
      id: "",
      title: "",
      show: false,
      overlayStyle: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      },
      quesionData: {}, // 题目数据
      currentIndex: 0, // 当前题目的索引
      selectData: { answers: [] }, // 选中的答案数据
      ratingBox: "ratingBox",
      groupRatingBox: "groupRatingBox",
      showCard: false,
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // 单组选项题目数据
    currentItem() {
      return this.quesionData.questions[this.currentIndex];
    },
    ShowSubmitButton() {
      if (
        this.quesionData.questions &&
        this.currentIndex === this.quesionData.questions.length - 1
      ) {
        if (this.currentItem.type !== "GROUP") {
          return (
            this.getSelectedAnswer(this.currentIndex) &&
            this.getSelectedAnswer(this.currentIndex).selectedIndex !== null
          );
        } else {
          return this.currentItem.groupQuestions.every(
            (groupItem, groupIndex) =>
              this.getGroupSelectedAnswer(this.currentIndex, groupIndex) &&
              this.getGroupSelectedAnswer(this.currentIndex, groupIndex)
                .selectedIndex !== null
          );
        }
      }
      return false;
    },
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toCardItem(item, index) {
      if (document.getElementById("ratingBox" + this.currentIndex)) {
        document.getElementById("ratingBox" + this.currentIndex).innerHTML = "";
      }
      this.currentIndex = index;
      // this.getQuesionList();

      this.showCard = false;
    },
    showAnswerCard() {
      this.showCard = true;

      this.quesionData.questions.map((question, index) => {
        let isDone = false;
        // 判断q是否完成选择
        if (question.type !== "GROUP") {
          isDone =
            this.getSelectedAnswer(index) &&
            this.getSelectedAnswer(index).selectedIndex !== null;
        } else {
          isDone = question.groupQuestions.every(
            (groupItem, groupIndex) =>
              this.getGroupSelectedAnswer(index, groupIndex) &&
              this.getGroupSelectedAnswer(index, groupIndex).selectedIndex !==
                null
          );
        }
        console.log(isDone);
        question.isDone = isDone;
      });
      console.log(this.quesionData.questions);
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 判断当前题目是否完成
    isCurrentDone(index) {
      if (this.quesionData.questions) {
      const question = this.quesionData.questions[index];
      console.log('当前题目',question);
      
      if (question.type !== "GROUP") {
        console.log("判断是否选择", question);
        return (
          this.getSelectedAnswer(index) &&
          this.getSelectedAnswer(index).selectedIndex !== null
        );
      } else {
        console.log("判断是否选择", question);
        return question.groupQuestions.every(
          (groupItem, groupIndex) =>
            this.getGroupSelectedAnswer(index, groupIndex) &&
            this.getGroupSelectedAnswer(index, groupIndex)
              .selectedIndex !== null
        );
        }
      }
      return false
    },
    async getQuesionList() {
      const res = await getQuesion({ id: this.id });
      this.quesionData = res.data;
      // this.quesionData.guidelines = '阿克苏对接焊缝拉科技三打哈饭卡垃圾啊很大索拉卡飞机哈卡打撒'; // 测试用

      this.quesionData.questions.map((q) => {
        q.isDone = false;
      });
      this.createdQuestion();
    },
    createdQuestion() {
      this.$nextTick(() => {
        if (this.quesionData.questions[this.currentIndex].type == "RATING") {
          this.RatingBox = "groupRatingBox" + this.currentIndex;
          this.adjustWidths(
            this.quesionData.questions[this.currentIndex].options,
            "ratingBox" + this.currentIndex
          ); // 调用函数，调整宽度
        }
        if (
          this.quesionData.questions[this.currentIndex].type == "GROUP" &&
          this.quesionData.questions[this.currentIndex].questionType == "RATING"
        ) {
          this.quesionData.questions[this.currentIndex].groupQuestions.forEach(
            (groupItem, groupIndex) => {
              this.groupRatingBox = "groupRatingBox" + groupIndex;
              this.adjustWidths(groupItem.options, this.groupRatingBox);
            }
          );
        }
      });
    },
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },
    rgbToHex(r, g, b) {
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    interpolateColor(startColor, endColor, factor) {
      const startRgb = this.hexToRgb(startColor);
      const endRgb = this.hexToRgb(endColor);
      const r = Math.round(startRgb.r + factor * (endRgb.r - startRgb.r));
      const g = Math.round(startRgb.g + factor * (endRgb.g - startRgb.g));
      const b = Math.round(startRgb.b + factor * (endRgb.b - startRgb.b));
      return this.rgbToHex(r, g, b);
    },
    adjustWidths(arr, id) {
      // console.log('看看options',arr,id);
      const quesionContainer = document.getElementById(id);
      quesionContainer.innerHTML = ""; // 清空容器
      arr.forEach((option, index) => {
        const div = document.createElement("div");
        div.classList.add("ratingItem");
        // 给div添加id
        // console.log('看看option.id',option.id);
        div.id = `${option.id}`;
        // 添加点击事件监听器
        if (this.currentItem.type == "RATING") {
          div.addEventListener("click", () =>
            this.handleRatingItemClick(option, index, "RATING")
          );
        } else if (
          this.currentItem.type == "GROUP" &&
          this.currentItem.questionType == "RATING"
        ) {
          div.addEventListener("click", () =>
            this.handleRatingItemClick(
              option,
              index,
              "GROUP",
              id.split("groupRatingBox")[1]
            )
          );
        }
        quesionContainer.appendChild(div);
      });
      const ratingItems = quesionContainer.querySelectorAll(".ratingItem");
      const n = arr.length;
      // 如果是奇数长度
      if (n % 2 === 1) {
        const middleIndex = Math.floor(n / 2);
        ratingItems[middleIndex].style.width = "30px"; // 中间元素宽度
        ratingItems[middleIndex].style.height = "30px"; // 中间元素宽度
        ratingItems[middleIndex].style.backgroundColor = "#73DEAA";
        ratingItems[middleIndex].style.borderRadius = "50%";
        // 动态计算外侧元素宽度和颜色
        ratingItems.forEach((element, index) => {
          if (index !== middleIndex) {
            // 计算距离中间元素的“层级”，每个外层加 10px
            const distance = Math.abs(index - middleIndex);
            element.style.width = `${30 + distance * 10}px`; // 根据层级动态计算宽度
            element.style.height = `${30 + distance * 10}px`; // 根据层级动态计算宽度
            element.style.borderRadius = "50%";

            const factor = distance / middleIndex;
            if (index < middleIndex) {
              // 左半部分
              element.style.backgroundColor = this.interpolateColor(
                "#73DEAA",
                "#83E699",
                factor
              );
            } else {
              // 右半部分
              element.style.backgroundColor = this.interpolateColor(
                "#73DEAA",
                "#68D8B7",
                factor
              );
            }
          }
        });
      }
      // 如果是偶数长度
      else {
        const middleIndex1 = n / 2 - 1; // 中间第一个元素
        const middleIndex2 = n / 2; // 中间第二个元素
        ratingItems[middleIndex1].style.width = "30px"; // 中间左侧元素宽度
        ratingItems[middleIndex1].style.height = "30px"; // 中间左侧元素宽度
        ratingItems[middleIndex1].style.backgroundColor = "#73DEAA";
        ratingItems[middleIndex1].style.borderRadius = "50%";
        ratingItems[middleIndex2].style.width = "30px"; // 中间右侧元素宽度
        ratingItems[middleIndex2].style.height = "30px"; // 中间右侧元素宽度
        ratingItems[middleIndex2].style.backgroundColor = "#6EDBB1";
        ratingItems[middleIndex2].style.borderRadius = "50%";
        // 动态计算外侧元素宽度和颜色
        ratingItems.forEach((element, index) => {
          if (index !== middleIndex1 && index !== middleIndex2) {
            // 计算距离中间元素的“层级”，每个外层加 10px
            const distance1 = Math.abs(index - middleIndex1); // 距离左侧中间元素
            const distance2 = Math.abs(index - middleIndex2); // 距离右侧中间元素
            const distance = Math.min(distance1, distance2); // 取最小距离
            element.style.width = `${30 + distance * 10}px`; // 根据层级动态计算宽度
            element.style.height = `${30 + distance * 10}px`; // 根据层级动态计算宽度
            element.style.borderRadius = "50%";
            const factor = distance / (n / 2);
            if (index < middleIndex1) {
              // 左半部分
              element.style.backgroundColor = this.interpolateColor(
                "#73DEAA",
                "#83E699",
                factor
              );
            } else {
              // 右半部分
              element.style.backgroundColor = this.interpolateColor(
                "#73DEAA",
                "#68D8B7",
                factor
              );
            }
          }
        });
      }
    },
    // 程度题选项点击事件
    handleRatingItemClick(option, index, type, groupIndex = null) {
      console.log("看看所有传参", option, index, type, groupIndex);
      if (type == "RATING") {
        let obj = {
          questionId: this.quesionData.questions[this.currentIndex].id,
          selected: [
            {
              selectedIndex: index + 1,
              selectedContent: option.content || `程度${index + 1}`,
            },
          ],
        };
        // 清空id 为ratingBox0 dom下的is_selected 类
        let isSelected = document.querySelectorAll(
          `#ratingBox${this.currentIndex} .is_selected`
        );
        for (let i = 0; i < isSelected.length; i++) {
          isSelected[i].classList.remove("is_selected");
        }
        // 获取div的id 等于 obj.quesiontId 的dow,添加is_selected 类
        let dow = document.getElementById(option.id);
        // console.log('看看dow',dow,option.id);
        if (dow) {
          dow.classList.add("is_selected");
        }
        // console.log('kanakn shuju ',obj );
        this.updateSelectData(obj);
      } else if (type == "GROUP") {
        let obj = {
          questionId: this.quesionData.questions[this.currentIndex]
            .groupQuestions[groupIndex].id,
          selected: [
            {
              selectedIndex: index + 1,
              selectedContent: option.content || `程度${index + 1}`,
            },
          ],
        };
        let isSelected = document.querySelectorAll(
          `#groupRatingBox${groupIndex} .is_selected`
        );
        for (let i = 0; i < isSelected.length; i++) {
          isSelected[i].classList.remove("is_selected");
        }
        let dow = document.getElementById(option.id);
        // console.log('看看dow',dow,option.id);
        if (dow) {
          dow.classList.add("is_selected");
        }
        this.updateSelectData(obj);
      }
      this.$forceUpdate();
    },
    // 上一题
    toPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.createdQuestion();
        this.createdSelected();
        // this.getQuesionList();
      }
    },
    // 下一题
    toNext() {
      if (document.getElementById("ratingBox" + this.currentIndex)) {
        document.getElementById("ratingBox" + this.currentIndex).innerHTML = "";
      }
      this.currentIndex++;
      this.createdQuestion();
      this.createdSelected();
      // this.getQuesionList();

      // if (
      //   this.selectData.answers.find(
      //     (answer) =>
      //       answer.questionId ===
      //       this.quesionData.questions[this.currentIndex].id
      //   )
      // ) {
      //   console.log("已经选择了");

      //   this.currentIndex++;
      //   this.getQuesionList();
      //   const currentQuestionId = this.quesionData.questions[this.currentIndex]
      //     .id;
      //   if (
      //     !this.selectData.answers.find(
      //       (answer) => answer.questionId === currentQuestionId
      //     )
      //   ) {
      //     this.selectData.answers.push({
      //       questionId: currentQuestionId,
      //       selected: [],
      //     });
      //   }
      // }
    },
    createdSelected() {
      // console.log("选中的答案数据", this.selectData);
      // 选出this.quesionData.questions中第this.currentIndex项
      const question = this.quesionData.questions[this.currentIndex];
      let answerItem;
      let index;
      let option;
      if (question.type === "RATING") {
        answerItem = this.selectData.answers.find(
          (item) => item.questionId === question.id
        );
        // console.log('option.type==="RATING"',question,answerItem);
        if (answerItem) {
          index = answerItem.selected[0].selectedIndex - 1;
          option = question.options[index];
          this.$nextTick(() => {
            this.handleRatingItemClick(option, index, "RATING");
          });
        }
      }
      if (question.type === "GROUP" && question.questionType === "RATING") {
        question.groupQuestions.map((groupItem, gIdx) => {
          answerItem = this.selectData.answers.find(
            (item) => item.questionId === groupItem.id
          );
          console.log(
            'option.type==="GROUP"&&question.questionType==="RATING"',
            question,
            option,
            answerItem
          );
          if (answerItem) {
            const cIndex = answerItem.selected[0].selectedIndex - 1;
            this.$nextTick(() => {
              this.handleRatingItemClick(
                groupItem.options[cIndex],
                cIndex,
                "GROUP",
                gIdx
              );
            });
          }
        });
      }
    },
    // 校验当前题目是否完成
    checkCurrentQuestion() {
      console.log("校验当前题目", this.currentIndex);
      const index = this.currentIndex;
      const question = this.quesionData.questions[this.currentIndex];
      console.log("看看currentItem", question);
      if (question.type !== "GROUP") {
        console.log("判断是否选择", question);

        return (
          this.getSelectedAnswer(index) &&
          this.getSelectedAnswer(index).selectedIndex !== null
        );
      } else {
        console.log("判断是否选择", question);
        return question.groupQuestions.every(
          (groupItem, groupIndex) =>
            this.getGroupSelectedAnswer(index, groupIndex) &&
            this.getGroupSelectedAnswer(index, groupIndex).selectedIndex !==
              null
        );
      }
      // if (
      //   this.selectData.answers.find(
      //     (answer) => answer.questionId === this.currentQuestionId
      //   )
      // ) {
      //   return true;
      // }
      // debugger;
      // return true;
    },
    // 单选题点击事件
    handleSingleItemClick(item, index, type, groupIndex = null) {
      if (type === "SINGLE") {
        let obj = {
          questionId: this.quesionData.questions[this.currentIndex].id,
          selected: [
            { selectedIndex: index + 1, selectedContent: item.content },
          ],
        };
        this.updateSelectData(obj);
      } else if (type === "GROUP") {
        let obj = {
          questionId: this.quesionData.questions[this.currentIndex]
            .groupQuestions[groupIndex].id,
          selected: [
            { selectedIndex: index + 1, selectedContent: item.content },
          ],
        };
        this.updateSelectData(obj);
        this.quesionData.questions[this.currentIndex].groupQuestions[
          groupIndex
        ].answerShow = false;
      }
      this.$forceUpdate();
    },
    // 更新选中的答案数据
    updateSelectData(obj) {
      const existingAnswerIndex = this.selectData.answers.findIndex(
        (answer) => answer.questionId === obj.questionId
      );
      if (existingAnswerIndex !== -1) {
        this.selectData.answers.splice(existingAnswerIndex, 1, obj);
      } else {
        this.selectData.answers.push(obj);
      }
    },
    getSelectedAnswer(index) {
      const answer = this.selectData.answers.find(
        (answer) => answer.questionId === this.quesionData.questions[index].id
      );
      if (answer && answer.selected.length > 0) {
        return answer.selected[0];
      }
      return {
        selectedIndex: null,
        selectedContent: null,
      }; // 提供默认值
    },

    getGroupSelectedAnswer(index, groupIndex) {
      const answer = this.selectData.answers.find(
        (answer) =>
          answer.questionId ===
          this.quesionData.questions[index].groupQuestions[groupIndex].id
      );
      if (answer && answer.selected.length > 0) {
        return answer.selected[0];
      }
      return null;
    },
    // 多组选项题（文本类型）题目点击事件
    handleGroupTextClick(item, index) {
      // 取反当前题目的 answerShow 值
      this.quesionData.questions[this.currentIndex].groupQuestions[
        index
      ].answerShow = !this.quesionData.questions[this.currentIndex]
        .groupQuestions[index].answerShow;
      this.$forceUpdate();
    },
    // 提交答案
    submit() {
      console.log("看看怎么保存的", this.quesionData.questions);
      // return false;
      if (this.quesionData.questions) {
        const allQuestionsAnswered = this.quesionData.questions.every(
          (question, index) => {
            if (question.type !== "GROUP") {
              console.log("判断是否选择", question);

              return (
                this.getSelectedAnswer(index) &&
                this.getSelectedAnswer(index).selectedIndex !== null
              );
            } else {
              console.log("判断是否选择", question);
              return question.groupQuestions.every(
                (groupItem, groupIndex) =>
                  this.getGroupSelectedAnswer(index, groupIndex) &&
                  this.getGroupSelectedAnswer(index, groupIndex)
                    .selectedIndex !== null
              );
            }
          }
        );
        if (allQuestionsAnswered) {
          const postData = {
            answers: this.selectData.answers.map((answer) => ({
              questionId: answer.questionId,
              selected: answer.selected.map(
                (selectedItem) => selectedItem.selectedIndex
              ),
            })),
          };
          console.log("submit数据", allQuestionsAnswered, postData);
          // return false; // 测试注释
          submitAnswer(postData, this.id).then((res) => {
            if (res.msg == "success") {
              if (this.type == 1) {
                this.$router.replace({
                  path: "/result",
                  query: {
                    reportId: res.data,
                    type: this.type,
                    title: this.title,
                  },
                });
              } else {
                this.$router.replace({
                  path: "/report",
                  query: {
                    type: this.type,
                    id: this.id,
                    reportId: res.data,
                  },
                });
              }
            } else {
              Toast(res.msg);
            }
          });
        } else {
          Toast("请确认所有题目已完成作答");
        }
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.show = true;
    }
    this.id = this.$route.query.id;
    this.title = this.$route.query.title;
    document.title = this.title;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getQuesionList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
// @import "~@/styles/variable.scss";
.container {
  overscroll-behavior: none;
  overflow-y: auto;
  color: #333333;
  // height: 100vh;
  background-color: #f3f4f6;
}
.navigator {
  width: 100vw;
  height: 88px;
  color: #292929;
  padding: 25px 30px;
  /* position: fixed; */
  top: 0px;
  left: 0;
  z-index: 1;
  text-align: center;
  background-color: #ffffff;
  .back_share {
    width: 100%;
    .back_img {
      width: 21px;
      height: 38px;
      float: left;
    }
    .nav_title {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #292929;
      line-height: 72px;
    }
  }
}
.answerPage {
  width: 100vw;
  padding: 24px 24px 24px 24px;
  .quesion_box {
    padding: 35px 27px;
    width: 100%;
    background: #ffffff;
    border-radius: 30px;
    .quesion_progress {
      .num_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .quesion_num {
          .now_num {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 30px;
            color: #4bd19e;
          }
          .total_num {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 30px;
            color: #111010;
          }
        }
        .sheet_box {
          display: flex;
          align-items: center;
          .sheet_img {
            width: 25px;
            height: 27px;
          }
          .sheet_text {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #666666;
            margin-left: 12px;
          }
        }
      }
      .progress_box {
        margin: 21px 0 35px 0;
      }
    }
    .question_guidelines {
      padding: 20px;
      background: #f5faf9;
      border-radius: 10px;
      margin-bottom: 20px;
      font-size: 24px;
    }
    .quesion_content {
      .quesion_title {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 28px;
        color: #333333;
      }
      .quesion_suntitle {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 24px;
        color: #c5c4c9;
        margin-top: 10px;
      }
      .answer_content {
        margin: 95px 0 125px 0;
        .rating_box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          gap: 20px;
        }
        .rating_text {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 24px;
          &_inner {
            width: 245px;
            &.inner_left {
              text-align: left;
            }
            &.inner_right {
              text-align: right;
            }
          }
        }
        .select_content {
          margin-top: 100px;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 24px;
          span {
            color: #47c998;
          }
        }
      }
      .answer_content_rating_group {
        margin: 25px 0 25px 0;
        .rating_text {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 24px;
          &_inner {
            width: 245px;
            &.inner_left {
              text-align: left;
            }
            &.inner_right {
              text-align: right;
            }
          }
        }
        .group_quesion_title {
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 24px;
          color: #c5c4c9;
          margin-top: 10px;
        }
        .group_rating_box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          gap: 20px;
          margin: 30px 0;
        }
        .select_content {
          margin: 30px 0;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 24px;
          span {
            color: #47c998;
          }
        }
      }
      .answer_content_single {
        margin-top: 62px;
      }
      .quesion_img {
        width: 100%;
        height: auto;
        margin-bottom: 20px;
        border-radius: 50px;
      }
      .answer_list {
        padding: 0 10px;
        text-align: center;
        .answer_item {
          display: flex;
          justify-content: center;
          width: 100%;
          min-height: 88px;
          background: #f9f9f9;
          border-radius: 44px;
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #222222;
          margin-bottom: 42px;
          padding: 30px;
          &.active {
            background: linear-gradient(90deg, #79e695, #5ad8b7);
            color: #ffffff;
          }
          .answer_item_inner {
            text-align: left;
          }
        }
      }
      .answer_list_image {
        /* display: grid; */
        grid-column-gap: 30px;
        grid-row-gap: 42px;
        grid-template-columns: 670px auto;
        justify-content: space-between;
        .answer_list_image_item{
          margin-bottom: 50px;
        }
      }
      .answer_item_group {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        background-color: #f3fbf7;
        border-radius: 50px;
        border:1px solid #c6c6c6
      }
      .answer_item_group.active {
        border: 1px solid #42c8a2;
      }
      .group_quesion_index {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 40px;
        left: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #222222;
      }
      .answer_item_img {
        /* position: absolute; */
        width: 100%;
        height: auto;
      }
      .answer_content_text_group {
        .group_quesion_text_content {
          .group_quesion_text_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #666666;
            margin-top: 24px;
            width: 100%;
            background: #f4f4f4;
            border-radius: 33px;
            border: 1px solid #d3d3d3;
            padding: 15px 25px;
            margin-bottom: 24px;
            .status_box {
              display: flex;
              align-items: center;
            }
            .selected_status {
              width: 113px;
              height: 38px;
              background: #ffffff;
              border-radius: 19px;
              line-height: 38px;
              text-align: center;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 20px;
              color: #47c998;
              margin-right: 15px;
            }
            img {
              width: 20px;
              height: 11px;
            }
          }
          .answer_group_list {
            .answer_item {
              display: flex;
              justify-content: center;
              width: 100%;
              min-height: 88px;
              background: #f9f9f9;
              border-radius: 44px;
              text-align: center;
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 28px;
              color: #222222;
              margin-bottom: 42px;
              padding: 30px;
              &.active {
                background: linear-gradient(90deg, #79e695, #5ad8b7);
                color: #ffffff;
              }
              .answer_item_inner {
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
  .btn_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 34px 42px 64px 42px;
    background-color: #f3f4f6;
    .btn_item {
      width: 100%;
      height: 101px;
      background: #ffffff;
      border-radius: 50px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #3fcda0;
      margin-left: 32px;
      border: none;
    }
    .btn_item:first-child {
      margin: 0;
    }
  }
  .dialog_box {
    .dialog_content {
      text-align: center;
      padding-bottom: 42px;
      .dialog_child {
        margin: 27px 42px 56px auto;
        // min-height: 300px;
        // max-height: 400px;
        width: 534px;
        height: 406px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #000000;
        line-height: 48px;
        overflow-y: scroll;
        /* -webkit-overflow-scrolling: touch; // 优化移动端滚动体验 */
        // 强制显示滚动条（针对Webkit浏览器）
        &::-webkit-scrollbar {
          display: initial;
          width: 6px;
          background-color: #f1f1f1;
          border-radius: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
          display: initial;
          
          background-color: #c1c1c1;
          border-radius: 3px;
          
          &:hover {
            background-color: #a8a8a8;
          }
        }
        .diloag_child_content{
          text-align: left;
          /* 回车换行 */
          white-space: pre-line;
          word-wrap: break-word;
          word-break: break-all;
          padding-right:6px
        }
        .dialog_img {
          width: 534px;
          height: auto;
        }
      }
      .dialog_btn {
        width: 560px;
        height: 83px;
        background: linear-gradient(90deg, #79e695, #5ad8b7);
        border-radius: 42px;
        line-height: 83px;
        text-align: center;
        margin: 0 auto;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #ffffff;
      }
    }
  }
}
.question_card_wrap {
  width: 100%;
  padding: 40px 30px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.question_card_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fcfcfc;
  color: #52d09f;
  border: 1px solid #e5e5e5;
  border-radius: 20px;
  width: 150px;
  height: 150px;
  margin-bottom: 30px;
  font-size: 68px;
  &.active {
    background: linear-gradient(90deg, #79e693, #79e7ca);
    color: #fff;
  }
  .card_item_tips {
    font-size: 24px;
  }
}
</style>
<style lang="scss">
.dialog_box {
  width: 640px;
  height: 692px;
  background-color: transparent;
  background-image: url("../../assets/images/answer/dialog_bg.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  .van-dialog__header {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 36px;
    color: #000000;
    padding: 44px 0 0 0;
  }
}
.ratingItem.is_selected {
  box-shadow: -6px -6px 10px -4px #83e699, 6px -6px 10px -4px #68d8b7,
    6px 6px 10px -4px #83e699, 6px 6px 10px -4px rgba(0, 0, 255, 2.75);
}
</style>
